import { useMutation } from "@tanstack/react-query";
import { getInventory, getInventoryVendor } from "../../api/inventory";
import { getTools, toolingError } from "../../api/tooling";
import { downloadCsv } from "../../utils/funcs/csv";

export type InventoryCategory = "client" | "vendor" | "toolings";

export default function InventoryDownloadButton({
  category,
}: {
  category: InventoryCategory;
}) {
  const download = useMutation({
    mutationFn: async (selected: InventoryCategory) => {
      const records = await (selected === "toolings"
        ? getTools(true)
        : selected === "vendor"
        ? getInventoryVendor()
        : getInventory());
      if (!records.length) throw new Error("There are no items to download.");
      downloadCsv(
        records,
        `${selected === "toolings" ? "toolings" : `${selected}_items`}.csv`
      );
    },
  });
  return (
    <div>
      <button
        type="button"
        className="styled-btn--std me-2"
        disabled={download.isLoading}
        onClick={() => download.mutate(category)}
      >
        {download.isLoading ? "Downloading..." : "Download"}
      </button>
      {download.isError && (
        <div className="text-danger small mt-1" role="alert">
          {toolingError(download.error)}
        </div>
      )}
    </div>
  );
}
